import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Loader, Icon } from 'semantic-ui-react';
import Chart from 'chart.js/auto';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import './Dashboard.css';
import api from '../../api';
import gradeA from '../../images/components/dashboard_header/companyGrade (A).png';
import gradeB from '../../images/components/dashboard_header/companyGrade (B).png';
import gradeC from '../../images/components/dashboard_header/companyGrade (C).png';
import gradeD from '../../images/components/dashboard_header/companyGrade (D).png';
import upSideArrow from '../../images/components/dashboard_header/upsideArrow.png';
import downSideArrow from '../../images/components/dashboard_header/downsideArrow.png';
//import exportIcon from '../../images/components/dashboard_header/export_icon.svg';
import Footer from '../Footer/Footer';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.compChart = null;
    this.wGradeChart = null;
    this.mGradeChart = null;
    this.securityStatusChart = null;
    this.licenseStatusChart = null;
    this.state = {
      isLoading: false,
      componentCount: {
        total: '',
        has_risk: '',
      },
      componentMostFound: [],
      licenseGrade: '',
      licenseProjects: {},
      litigatorMostFound: [],
      litigatorProjects: '',
      overallProjects: {},
      securityGrade: '',
      securityProjects: {},
      weeklyGradeTrend: {
        trend: [],
        difference: '',
        label: '',
      },
      monthlyGradeTrend: {
        trend: [],
        difference: '',
        label: '',
      },
      policyProjects: '',
      policyMostFound: [],
      monthlySecurityTrend: [],
      monthlyLicenseTrend: [],
    };
  }

  componentDidMount() {
    this.getDashboardSummary();
    if (this.pieChart) {
      this.drawPieChart();
    }
    if (this.wLineChart) {
      this.drawWeeklyLineChart();
    }
    if (this.mLineChart) {
      this.drawMonthlyLineChart();
    }

    if (this.lineChart_1) {
      this.drawSecurityLineChart();
    }

    if (this.lineChart_2) {
      this.drawLicenseLineChart();
    }

    $(document).on('mouseover', '.dashboard_summary .horizontal_bar_chart_table .name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.dashboard_summary .horizontal_bar_chart_table .value', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.dashboard_summary .table_type_01 td', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      componentCount,
      isLoading,
      weeklyGradeTrend,
      monthlyGradeTrend,
      monthlySecurityTrend,
      monthlyLicenseTrend
    } = this.state;

    if (Object.entries(componentCount).length !== 0 && prevState.componentCount.total !== componentCount.total && !isLoading) {
      this.drawPieChart();
    }
    if (Object.entries(weeklyGradeTrend).length !== 0 && prevState.weeklyGradeTrend.trend.length !== weeklyGradeTrend.trend.length && !isLoading) {
      this.drawWeeklyLineChart();
    }
    if (Object.entries(monthlyGradeTrend).length !== 0 && prevState.monthlyGradeTrend.trend.length !== monthlyGradeTrend.trend.length && !isLoading) {
      this.drawMonthlyLineChart();
    }
    if (prevState.monthlySecurityTrend.length !== monthlySecurityTrend.length && !isLoading) {
      this.drawSecurityLineChart();
    }
    if (prevState.monthlyLicenseTrend.length !== monthlyLicenseTrend.length && !isLoading) {
      this.drawLicenseLineChart();
    }
  }

  componentWillUnmount() {
    if (this.compChart) {
      this.compChart.destroy();
    }
    if (this.wGradeChart) {
      this.wGradeChart.destroy();
    }
    if (this.mGradeChart) {
      this.mGradeChart.destroy();
    }
    if (this.securityStatusChart) {
      this.securityStatusChart.destroy();
    }
    if (this.licenseStatusChart) {
      this.licenseStatusChart.destroy();
    }
  }

  calcPercentages = (hiddenArray, data) => {
    const percentageData = [];
    let i = 0;

    for (i; i < data.length; i++) {
      percentageData.push([]);
    }

    Object.keys(data[0]).forEach((innerKey) => {
      let sum = 0;
      Object.keys(data).forEach((outerKey) => {
        sum += data[outerKey][innerKey];
      });

      Object.keys(data).forEach((outerKey) => {
        if (hiddenArray[outerKey]) {
          percentageData[outerKey][innerKey] = 0;
        } else {
          percentageData[outerKey][innerKey] = (data[outerKey][innerKey] / sum) * 100;
          if (isNaN(parseFloat(percentageData[outerKey][innerKey]))) {
            percentageData[outerKey][innerKey] = 0;
          }
        }
      });
    });
    return percentageData;
  };

  getDashboardSummary = () => {
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getDashboardSummary()
        .then((response) => {
          const data = response.response;
          this.setState({
            companyName: data.company_name,
            companyGrade: data.company_grade,
            componentCount: data.component_count,
            componentMostFound: data.component_most_found,
            licenseGrade: data.license_grade,
            licenseProjects: data.license_projects,
            litigatorMostFound: data.litigator_most_found,
            litigatorProjects: data.litigator_projects,
            monthlyGradeTrend: data.monthly_grade_trend,
            overallProjects: data.overall_projects,
            securityGrade: data.security_grade,
            securityProjects: data.security_projects,
            weeklyGradeTrend: data.weekly_grade_trend,
            policyProjects: data.policy_projects,
            policyMostFound: data.policy_most_found,
            monthlySecurityTrend: data.monthly_security_trend,
            monthlyLicenseTrend: data.monthly_license_trend,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            //error: t('modal.error.error_load'),
            isLoading: false,
          });
        });
    });
  };

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  drawPieChart() {
    const { t } = this.props;
    if (this.compChart) {
      this.compChart.destroy();
      this.compChart = null;
    }
    const { componentCount } = this.state;
    const config = {
      type: 'doughnut',
      data: {
        datasets: [
          {
            label: [t('chart.title.safety'), t('chart.title.risk')],
            data: [componentCount.has_risk, componentCount.total - componentCount.has_risk],
            backgroundColor: ['#ff8d00', '#b7b7b7'],
            borderWidth: [0, 0],
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    };

    const ctx = this.pieChart.getContext('2d');
    this.compChart = new Chart(ctx, config);
  }

  drawWeeklyLineChart() {
    const { weeklyGradeTrend } = this.state;
    if (this.wGradeChart) {
      this.wGradeChart.destroy();
      this.wGradeChart = null;
    }

    const config = {
      type: 'line',
      data: {
        borderWidth: 8,
        labels: ['', '', '', '', ''],
        datasets: [
          {
            data: weeklyGradeTrend.trend,
            backgroundColor: '#8dff33',
            borderColor: '#8dff33',
            fill: false,
            borderWidth: 8,
            pointStyle: false,
            tension: 0.1,
            clip: 20,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            type: 'linear',
            min: 0,
            max: 100,
            display: false,
          },
          x: {
            display: false,
          }
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
      },
    };

    const ctx = this.wLineChart.getContext('2d');
    this.wGradeChart = new Chart(ctx, config);
  }

  drawMonthlyLineChart() {
    if (this.mGradeChart) {
      this.mGradeChart.destroy();
      this.mGradeChart = null;
    }
    const { monthlyGradeTrend } = this.state;

    const config = {
      type: 'line',
      data: {
        borderWidth: 8,
        labels: ['', '', '', '', ''],
        datasets: [
          {
            data: monthlyGradeTrend.trend,
            backgroundColor: ['#8dff33'],
            borderColor: '#8dff33',
            fill: false,
            borderWidth: 8,
            pointStyle: false,
            tension: 0.1,
            clip: 20,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            type: 'linear',
            min: 0,
            max: 100,
            display: false,
          },
          x: {
            display: false,
          }
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        }
      },
    };

    const ctx = this.mLineChart.getContext('2d');
    this.mGradeChart = new Chart(ctx, config);
  }

  drawSecurityLineChart() {
    if (this.securityStatusChart) {
      this.securityStatusChart.destroy();
      this.securityStatusChart = null;
    }

    const { monthlySecurityTrend } = this.state;
    const { t } = this.props;
    const dataSet = [];

    const undecidedArray = monthlySecurityTrend.map((item) => {
      return item.undecided;
    });

    dataSet.push(undecidedArray);

    const resolvedArray = monthlySecurityTrend.map((item) => {
      return item.resolved;
    });

    dataSet.push(resolvedArray);

    const disregardedArray = monthlySecurityTrend.map((item) => {
      return item.disregarded;
    });

    dataSet.push(disregardedArray);

    const hiddenArray = [];
    let i = 0;

    for (i; i < dataSet.length; i++) {
      hiddenArray.push(null);
    }

    const percentageData = this.calcPercentages(hiddenArray, dataSet);

    const monthArray = monthlySecurityTrend.map((item) => {
      return item.month;
    });

    const config = {
      type: 'line',
      data: {
        labels: monthArray,
        datasets: [
          {
            backgroundColor: '#21beff',
            borderColor: '#21beff',
            label: t('chart.title.undecided'),
            data: percentageData[0],
            fill: true,
          },
          {
            backgroundColor: '#61e286',
            borderColor: '#61e286',
            label: t('chart.title.resolved'),
            data: percentageData[1],
            fill: true,
          },
          {
            backgroundColor: '#D0D0D0',
            borderColor: '#D0D0D0',
            label: t('chart.title.disregarded'),
            data: percentageData[2],
            fill: true,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }

                if (context.parsed.y !== null) {
                  label += `${Math.round(context.parsed.y)}%`;
                }

                return label;
              }
            },
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              color: '#777777',
            },
          },
        },
        scales: {
          y: {
            type: 'linear',
            grace: '5%',
            stacked: true,
            min: 0,
            max: 100,
            ticks: {
              padding: 2,
              callback(value) {
                return `${value}%`;
              }
            },
          },
          x: {
            lineHeight: '50px',
            ticks: {
              padding: 5,
              font: {
                size: 9,
              },
              color: '#afafaf',
            },
          },
        },
      },
    };

    const ctx = this.lineChart_1.getContext('2d');
    this.securityStatusChart = new Chart(ctx, config);
  }

  drawLicenseLineChart() {
    const { t } = this.props;

    if (this.licenseStatusChart) {
      this.licenseStatusChart.destroy();
      this.licenseStatusChart = null;
    }

    const { monthlyLicenseTrend } = this.state;
    const dataSet = [];

    const undecidedArray = monthlyLicenseTrend.map((item) => {
      return item.undecided;
    });

    dataSet.push(undecidedArray);

    const resolvedArray = monthlyLicenseTrend.map((item) => {
      return item.resolved;
    });

    dataSet.push(resolvedArray);

    const disregardedArray = monthlyLicenseTrend.map((item) => {
      return item.disregarded;
    });

    dataSet.push(disregardedArray);

    const hiddenArray = [];
    let i = 0;

    for (i; i < dataSet.length; i++) {
      hiddenArray.push(null);
    }

    const percentageData = this.calcPercentages(hiddenArray, dataSet);

    const monthArray = monthlyLicenseTrend.map((item) => {
      return item.month;
    });

    const config = {
      type: 'line',
      data: {
        labels: monthArray,
        datasets: [
          {
            backgroundColor: '#21beff',
            borderColor: '#21beff',
            label: t('chart.title.undecided'),
            data: percentageData[0],
            fill: true,
          },
          {
            backgroundColor: '#61e286',
            borderColor: '#61e286',
            label: t('chart.title.resolved'),
            data: percentageData[1],
            fill: true,
          },
          {
            backgroundColor: '#D0D0D0',
            borderColor: '#D0D0D0',
            label: t('chart.title.disregarded'),
            data: percentageData[2],
            fill: true,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }

                if (context.parsed.y !== null) {
                  label += `${Math.round(context.parsed.y)}%`;
                }

                return label;
              }
            },
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              color: '#777777',
            },
          },
        },
        scales: {
          y: {
            type: 'linear',
            grace: '5%',
            stacked: true,
            min: 0,
            max: 100,
            ticks: {
              padding: 2,
              callback(value) {
                return `${value}%`;
              }
            },
          },
          x: {
            lineHeight: '50px',
            ticks: {
              padding: 5,
              font: {
                size: 9,
              },
              color: '#afafaf',
            },
          },
        },
      },
    };

    const ctx = this.lineChart_2.getContext('2d');
    this.licenseStatusChart = new Chart(ctx, config);
  }

  renderGrade() {
    const { companyGrade } = this.state;
    if (companyGrade === 'A') {
      return <img src={gradeA} alt="" className="grade_a" />;
    } if (companyGrade === 'B') {
      return <img src={gradeB} alt="" className="grade_b" />;
    } if (companyGrade === 'C') {
      return <img src={gradeC} alt="" className="grade_c" />;
    } if (companyGrade === 'D') {
      return <img src={gradeD} alt="" className="grade_d" />;
    }
    return <Icon className="minus" style={{ color: '#fff' }} />;
  }

  render() {
    let barData;
    const {
      companyName,
      componentCount,
      componentMostFound,
      licenseGrade,
      licenseProjects,
      litigatorMostFound,
      litigatorProjects,
      monthlyGradeTrend,
      overallProjects,
      securityGrade,
      securityProjects,
      weeklyGradeTrend,
      policyProjects,
      policyMostFound,
      isLoading,
    } = this.state;

    const { t } = this.props;

    let securityObj = [];
    if (Object.entries(securityProjects).length !== 0) {
      securityObj = Object.keys(securityProjects).map((key) => {
        return securityProjects[key];
      });
    }

    let licenseObj = [];
    if (Object.entries(licenseProjects).length !== 0) {
      licenseObj = Object.keys(licenseProjects).map((key) => {
        return licenseProjects[key];
      });
    }

    return (
      <div>
        <div className="dashboard_header ">
          <div className="dashboard_header_inner">
            <div className="dashboard_header_box">
              <div className="compan">
                <p className="title">{companyName}</p>
                <div className="header_contnet">
                  <div className="medal">
                    <div className="grade">{this.renderGrade()}</div>
                  </div>
                </div>
                {/**
                <a className="export_icon">
                  <img src={exportIcon} alt="" className="" />
                </a>
                 */}
              </div>
              {overallProjects && overallProjects.All !== 0 ? (
                <div className="projects">
                  <p className="title">{t('dashboard.project')}</p>
                  <div className="header_contnet">
                    <table className="bar_chart_table">
                      <colgroup>
                        <col width="15%" />
                        <col width="25%" />
                        <col width="" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th className="green">A</th>
                          <td className="green">{overallProjects.A}</td>
                          <td className="green">
                            {overallProjects.A === 0 ? (
                              <div className="bar" style={{ width: '0%' }} />
                            ) : (
                              <div
                                className="bar"
                                style={{
                                  width: `${(overallProjects.A
                                    / overallProjects.All)
                                    * 100}%`,
                                }}
                              />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th className="yellow">B</th>
                          <td className="yellow">{overallProjects.B}</td>
                          <td className="yellow">
                            {overallProjects.B === 0 ? (
                              <div className="bar" style={{ width: '0%' }} />
                            ) : (
                              <div
                                className="bar"
                                style={{
                                  width: `${(overallProjects.B
                                    / overallProjects.All)
                                    * 100}%`,
                                }}
                              />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th className="orange">C</th>
                          <td className="orange">{overallProjects.C}</td>
                          <td className="orange">
                            {overallProjects.C === 0 ? (
                              <div className="bar" style={{ width: '0%' }} />
                            ) : (
                              <div
                                className="bar"
                                style={{
                                  width: `${(overallProjects.C
                                    / overallProjects.All)
                                    * 100}%`,
                                }}
                              />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th className="red">D</th>
                          <td className="red">{overallProjects.D}</td>
                          <td className="red">
                            {overallProjects.D === 0 ? (
                              <div className="bar" style={{ width: '0%' }} />
                            ) : (
                              <div
                                className="bar"
                                style={{
                                  width: `${(overallProjects.D
                                    / overallProjects.All)
                                    * 100}%`,
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="projects">
                  <p className="title">{t('dashboard.project')}</p>
                  <div className="header_contnet">
                    <table className="bar_chart_table">
                      <colgroup>
                        <col width="15%" />
                        <col width="25%" />
                        <col width="" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th className="green">A</th>
                          <td className="green">{overallProjects.A}</td>
                          <td className="green">
                            <div className="bar" style={{ width: '0%' }} />
                          </td>
                        </tr>
                        <tr>
                          <th className="yellow">B</th>
                          <td className="yellow">{overallProjects.B}</td>
                          <td className="yellow">
                            <div className="bar" style={{ width: '0%' }} />
                          </td>
                        </tr>
                        <tr>
                          <th className="orange">C</th>
                          <td className="orange">{overallProjects.C}</td>
                          <td className="orange">
                            <div className="bar" style={{ width: '0%' }} />
                          </td>
                        </tr>
                        <tr>
                          <th className="red">D</th>
                          <td className="red">{overallProjects.D}</td>
                          <td className="red">
                            <div className="bar" style={{ width: '0%' }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className="grade_trend">
                <p className="title">{t('dashboard.grade_trend')}</p>
                <div className="header_contnet">
                  <div className="line_chart_wrap">
                    {
                      isLoading ? (
                        <div className="line_chart_itme">
                          <Loader active size="large" inverted />
                        </div>
                      ) : (
                        <div className="line_chart_itme">
                          <div className="line_chart_info">
                            <div className="value">
                              {Math.abs(weeklyGradeTrend.difference)}
                              <em>%</em>
                            </div>
                            <p className="improved">
                              {weeklyGradeTrend.label}
                              {weeklyGradeTrend.difference < 0 ? (
                                <img src={downSideArrow} alt="" />
                              ) : (
                                <img src={upSideArrow} alt="" />
                              )}
                            </p>
                            <p className="date_type">{t('dashboard.weekly')}</p>
                          </div>
                          <div className="line_chart_box">
                            <canvas
                              ref={(ref) => {
                                this.wLineChart = ref;
                              }}
                              style={{ width: '110px', height: '70px' }}
                            />
                          </div>
                        </div>
                      )
                    }
                    {
                      isLoading ? (
                        <div className="line_chart_itme">
                          <Loader active size="large" inverted />
                        </div>
                      ) : (
                        <div className="line_chart_itme">
                          <div className="line_chart_info">
                            <div className="value">
                              {Math.abs(monthlyGradeTrend.difference)}
                              <em>%</em>
                            </div>
                            <p className="improved">
                              {monthlyGradeTrend.label}
                              {monthlyGradeTrend.difference < 0 ? (
                                <img src={downSideArrow} alt="" />
                              ) : (
                                <img src={upSideArrow} alt="" />
                              )}
                            </p>
                            <p className="date_type">{t('dashboard.monthly')}</p>
                          </div>
                          <div className="line_chart_box">
                            <canvas
                              ref={(ref) => {
                                this.mLineChart = ref;
                              }}
                              style={{ width: '110px', height: '70px' }}
                            />
                          </div>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contents">
          <div className="content">
            <div className="dashboard_summary">
              <div className="dashboard_table">
                <div className="cell">
                  <div className="dashboard_card">
                    <div className="card_header">
                      <h2 className="title">{t('dashboard.components')}</h2>
                      <p className="value">
                        <span>{componentCount && this.abbreviateNumber(componentCount.total)}</span>
                      </p>
                      <p className="unit">{t('chart.title.total')}</p>
                    </div>
                    <div className="card_content">
                      <div className="content_title">
                        {t('dashboard.components_with_issues')}
                      </div>
                      <div className="doughnut_chart_wrap">
                        {
                          isLoading ? (
                            <div className="doughnut_chart_item">
                              <Loader active size="large" />
                            </div>
                          ) : (
                            <div className="doughnut_chart_item">
                              <div className="doughnut_chart_box">
                                <canvas
                                  ref={(ref) => {
                                    this.pieChart = ref;
                                  }}
                                />
                              </div>
                              <div className="doughnut_chart_info">
                                <p className="no_issue">
                                  {t('dashboard.no_issues')}
                                  <span className="value">
                                    {componentCount && this.abbreviateNumber(componentCount.total - componentCount.has_risk)}
                                  </span>
                                </p>
                                <p className="with_issue">
                                  {t('dashboard.with_issues')}
                                  <span className="value">
                                    {componentCount && this.abbreviateNumber(componentCount.has_risk)}
                                  </span>
                                </p>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                    <div className="card_content">
                      <div className="content_title">{t('dashboard.most_identified')}</div>
                      {componentMostFound && (
                        <div className="horizontal_bar_chart_wrap">
                          <table className="horizontal_bar_chart_table">
                            <colgroup>
                              <col style={{ width: '10%' }} />
                              <col style={{ width: '35%' }} />
                              <col style={{ width: '11%' }} />
                              <col style={{ width: '' }} />
                            </colgroup>
                            <tbody>
                              {componentMostFound.length !== 0 ? (
                                componentMostFound.map((item) => {
                                  if (item.project_count !== 0) {
                                    barData = (item.project_count
                                        / componentMostFound[0].project_count)
                                      * 100;
                                  } else {
                                    barData = 0;
                                  }
                                  return (
                                    <tr key={uuidv4()}>
                                      <td className="num">
                                        {item.rank}
                                        .
                                      </td>
                                      <td className="name">
                                        {item.component_name}
                                      </td>
                                      <td className="value">
                                        {item.project_count}
                                      </td>
                                      <td className="bar_wrap">
                                        <div
                                          className={cx('bar', {
                                            opacity_08: item.rank === 2,
                                            opacity_06: item.rank === 3,
                                            opacity_04: item.rank === 4,
                                            opacity_02: item.rank === 5,
                                          })}
                                          style={{ width: `${barData}%` }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="cell">
                  <div className="dashboard_card">
                    <div className="card_header">
                      <h2 className="title">{t('panel.menu.security')}</h2>
                      <p className="value">{securityGrade}</p>
                      <p className="unit">{t('dashboard.grade')}</p>
                    </div>
                    <div className="card_content">
                      <div className="content_title">
                        {t('dashboard.project_with_security_risks')}
                      </div>
                      <div className="bar_chart_wrap">
                        <table className="bar_chart_table">
                          <colgroup>
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '25%' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td>
                                <div className="bar_item red">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(securityProjects.Fatal
                                            / Math.max.apply(null, securityObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {securityProjects.Fatal}
                                  </p>
                                  <p className="bar_name">{t('dashboard.fatal')}</p>
                                </div>
                              </td>
                              <td>
                                <div className="bar_item orange">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(securityProjects.Poor
                                            / Math.max.apply(null, securityObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {securityProjects.Poor}
                                  </p>
                                  <p className="bar_name">{t('dashboard.poor')}</p>
                                </div>
                              </td>
                              <td>
                                <div className="bar_item yellow">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(securityProjects.Decent
                                            / Math.max.apply(null, securityObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {securityProjects.Decent}
                                  </p>
                                  <p className="bar_name">{t('dashboard.decent')}</p>
                                </div>
                              </td>
                              <td>
                                <div className="bar_item gray">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(securityProjects.Good
                                            / Math.max.apply(null, securityObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {securityProjects.Good}
                                  </p>
                                  <p className="bar_name">{t('dashboard.good')}</p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="card_content">
                      <div className="content_title">
                        {t('dashboard.trend_security_issue_status')}
                      </div>
                      <canvas
                        ref={(ref) => {
                          this.lineChart_1 = ref;
                        }}
                        className="line_chart line_chart_01"
                      />
                    </div>
                  </div>
                </div>
                <div className="cell">
                  <div className="dashboard_card">
                    <div className="card_header">
                      <h2 className="title">{t('panel.menu.license')}</h2>
                      <p className="value">{licenseGrade}</p>
                      <p className="unit">{t('dashboard.grade')}</p>
                    </div>
                    <div className="card_content">
                      <div className="content_title">
                        {t('dashboard.project_with_license_risks')}
                      </div>

                      <div className="bar_chart_wrap">
                        <table className="bar_chart_table">
                          <colgroup>
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '25%' }} />
                            <col style={{ width: '25%' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td>
                                <div className="bar_item red">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(licenseProjects.Fatal
                                            / Math.max.apply(null, licenseObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {licenseProjects.Fatal}
                                  </p>
                                  <p className="bar_name">{t('dashboard.fatal')}</p>
                                </div>
                              </td>
                              <td>
                                <div className="bar_item orange">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(licenseProjects.Poor
                                            / Math.max.apply(null, licenseObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {licenseProjects.Poor}
                                  </p>
                                  <p className="bar_name">{t('dashboard.poor')}</p>
                                </div>
                              </td>
                              <td>
                                <div className="bar_item yellow">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(licenseProjects.Decent
                                            / Math.max.apply(null, licenseObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {licenseProjects.Decent}
                                  </p>
                                  <p className="bar_name">{t('dashboard.decent')}</p>
                                </div>
                              </td>
                              <td>
                                <div className="bar_item gray">
                                  <div className="bar_area">
                                    <div
                                      className="bar"
                                      style={{
                                        height:
                                          `${(licenseProjects.Good
                                            / Math.max.apply(null, licenseObj))
                                            * 100}%` || '0%',
                                      }}
                                    />
                                  </div>
                                  <p className="bar_value">
                                    {licenseProjects.Good}
                                  </p>
                                  <p className="bar_name">{t('dashboard.good')}</p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="card_content">
                      <div className="content_title">
                        {t('dashboard.trend_license_issue_status')}
                      </div>
                      <canvas
                        ref={(ref) => {
                          this.lineChart_2 = ref;
                        }}
                        className="line_chart line_chart_02"
                      />
                    </div>
                  </div>
                </div>
                <div className="cell">
                  <div className="dashboard_card small small_top">
                    <div className="card_header">
                      <h2 className="title">{t('dashboard.litigator')}</h2>
                      <p className="value">
                        <span>{this.abbreviateNumber(litigatorProjects)}</span>
                      </p>
                      <p className="unit">{t('dashboard.detected')}</p>
                    </div>
                    <div className="card_content">
                      <div className="content_title">
                        {t('dashboard.projects_with_litigators')}
                      </div>
                      <table className="table_type_01">
                        <colgroup>
                          <col style={{ width: '10%' }} />
                          <col style={{ width: '40%' }} />
                          <col style={{ width: '' }} />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th>&nbsp;</th>
                            <th>{t('dashboard.name')}</th>
                            <th>{t('dashboard.projects')}</th>
                          </tr>
                          {litigatorMostFound.map((ltm) => {
                            return (
                              <tr key={uuidv4()}>
                                <td>
                                  {ltm.rank}
                                  .
                                </td>
                                <td>
                                  {ltm.code}
                                </td>
                                <td>{ltm.project_count}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="dashboard_card small small_bottom">
                    <div className="card_header">
                      <h2 className="title">
                        {t('dashboard.policy')}
                      </h2>
                      <p className="value">{this.abbreviateNumber(policyProjects)}</p>
                      <p className="unit">{t('dashboard.violated')}</p>
                    </div>
                    <div className="card_content">
                      <div className="content_title">
                        {t('dashboard.project_with_policy_violation')}
                      </div>
                      {
                        policyMostFound.length !== 0 ? (
                          <table className="table_type_01">
                            <colgroup>
                              <col style={{ width: '10%' }} />
                              <col style={{ width: '40%' }} />
                              <col style={{ width: '25%' }} />
                              <col style={{ width: '' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <th>&nbsp;</th>
                                <th>
                                  {t('dashboard.name')}
                                </th>
                                <th style={{ textAlign: 'left' }}>
                                  {t('dashboard.category')}
                                </th>
                                <th>
                                  {t('dashboard.projects')}
                                </th>
                              </tr>
                              {policyMostFound.map((pcm) => {
                                return (
                                  <tr key={uuidv4()}>
                                    <td>
                                      {pcm.rank}
                                      .
                                    </td>
                                    <td>
                                      {pcm.name}
                                    </td>
                                    <td style={{ textAlign: 'left' }}>{pcm.category}</td>
                                    <td>{pcm.project_count}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        ) : null
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withTranslation()(inject('state')(observer(Dashboard)));
